import { cn } from '../lib/utils';
import equipmentLight from '../assets/onboarding/equipment-light.webp';
import equipmentDark from '../assets/onboarding/equipment-dark.webp';
import clientsLight from '../assets/onboarding/clients-light.webp';
import clientsDark from '../assets/onboarding/clients-dark.webp';
import jobLight from '../assets/onboarding/job-light.webp';
import jobDark from '../assets/onboarding/job-dark.webp';
import crewLight from '../assets/onboarding/crew-light.webp';
import crewDark from '../assets/onboarding/crew-dark.webp';
import kitsLight from '../assets/onboarding/kits-light.webp';
import kitsDark from '../assets/onboarding/kits-dark.webp';
import archiveLight from '../assets/onboarding/archive-light.webp';
import archiveDark from '../assets/onboarding/archive-dark.webp';
import roiLight from '../assets/landing/roi-light.webp';
import roiDark from '../assets/landing/roi-dark.webp';
import quotesLight from '../assets/landing/quotes-light.webp';
import quotesDark from '../assets/landing/quotes-dark.webp';
import categoryLight from '../assets/landing/category-light.webp';
import categoryDark from '../assets/landing/category-dark.webp';
import breakevenLight from '../assets/landing/breakeven-light.webp';
import breakevenDark from '../assets/landing/breakeven-dark.webp';
import invoicingLight from '../assets/landing/invoicing-light.webp';
import invoicingDark from '../assets/landing/invoicing-dark.webp';
import speedLight from '../assets/landing/speed-light.webp';
import speedDark from '../assets/landing/speed-dark.webp';
import heroLight from '../assets/landing/hero-light.webp';
import heroDark from '../assets/landing/hero-dark.webp';
import statJobsLight from '../assets/stats/jobs-light.webp';
import statJobsDark from '../assets/stats/jobs-dark.webp';
import statBillingsLight from '../assets/stats/billings-light.webp';
import statBillingsDark from '../assets/stats/billings-dark.webp';
import statProfitLight from '../assets/stats/profit-light.webp';
import statProfitDark from '../assets/stats/profit-dark.webp';
import gearCameraLight from '../assets/gear/camera-light.webp';
import gearCameraDark from '../assets/gear/camera-dark.webp';
import gearMonitorLight from '../assets/gear/monitor-light.webp';
import gearMonitorDark from '../assets/gear/monitor-dark.webp';
import gearTransmitterLight from '../assets/gear/transmitter-light.webp';
import gearTransmitterDark from '../assets/gear/transmitter-dark.webp';
import gearBatteryLight from '../assets/gear/battery-light.webp';
import gearBatteryDark from '../assets/gear/battery-dark.webp';
import gearPrimeLight from '../assets/gear/prime-light.webp';
import gearPrimeDark from '../assets/gear/prime-dark.webp';
import gearPrimeShortLight from '../assets/gear/prime-short-light.webp';
import gearPrimeShortDark from '../assets/gear/prime-short-dark.webp';
import gearPanelLight from '../assets/gear/panel-light.webp';
import gearPanelDark from '../assets/gear/panel-dark.webp';
import gearCobLight from '../assets/gear/cob-light.webp';
import gearCobDark from '../assets/gear/cob-dark.webp';
import gearSlateLight from '../assets/gear/slate-light.webp';
import gearSlateDark from '../assets/gear/slate-dark.webp';
import tierSoloLight from '../assets/tiers/solo-light.webp';
import tierSoloDark from '../assets/tiers/solo-dark.webp';
import tierProjectsLight from '../assets/tiers/projects-light.webp';
import tierProjectsDark from '../assets/tiers/projects-dark.webp';
import tierProducerLight from '../assets/tiers/producer-light.webp';
import tierProducerDark from '../assets/tiers/producer-dark.webp';

const ART = {
  equipment: [equipmentLight, equipmentDark],
  clients: [clientsLight, clientsDark],
  job: [jobLight, jobDark],
  crew: [crewLight, crewDark],
  kits: [kitsLight, kitsDark],
  archive: [archiveLight, archiveDark],
  // Homepage feature panels, painted on canvas rather than surface
  roi: [roiLight, roiDark],
  quotes: [quotesLight, quotesDark],
  category: [categoryLight, categoryDark],
  breakeven: [breakevenLight, breakevenDark],
  invoicing: [invoicingLight, invoicingDark],
  speed: [speedLight, speedDark],
  // Homepage header background: 21:9, empty in the middle for the headline
  hero: [heroLight, heroDark],
  // Dashboard stat cards: 1:1, on surface; Profit on the inverse band
  statJobs: [statJobsLight, statJobsDark],
  statBillings: [statBillingsLight, statBillingsDark],
  statProfit: [statProfitLight, statProfitDark],
  // Homepage gear, 1:1 and transparent, so they sit on any card face
  gearCamera: [gearCameraLight, gearCameraDark],
  gearMonitor: [gearMonitorLight, gearMonitorDark],
  gearTransmitter: [gearTransmitterLight, gearTransmitterDark],
  gearBattery: [gearBatteryLight, gearBatteryDark],
  gearPrime: [gearPrimeLight, gearPrimeDark],
  gearPrimeShort: [gearPrimeShortLight, gearPrimeShortDark],
  gearPanel: [gearPanelLight, gearPanelDark],
  gearCob: [gearCobLight, gearCobDark],
  gearSlate: [gearSlateLight, gearSlateDark],
  // The plans, on surface: the homepage's plan boxes
  tierSolo: [tierSoloLight, tierSoloDark],
  tierProjects: [tierProjectsLight, tierProjectsDark],
  tierProducer: [tierProducerLight, tierProducerDark],
};

// Decorative illustration for onboarding panels, empty states, dashboard stat
// cards, plan tiers and the homepage, in the design system's "R5" style:
// Braun-era front elevations reduced to their fewest shapes, one ochre accent,
// a printed grain. Every line is redrawn so it is 2px wide on screen at the
// size the image is shown, so weights match across the set.
//
// Each image is painted on the exact colour of the surface it sits on, so it
// sits flush only there: assets/onboarding, assets/tiers and the stat cards on
// surface (#d1c6bb / #2f2923), assets/landing on canvas (#dacfc3 / #231e1a),
// and the Profit stat on inverse (#2f2923 / #e2decf). assets/gear and the stats
// are transparent, for faces that change. The dark variant swaps in
// under the .dark class.
// Generated with scripts/gen_image.py, then traced and restroked; see
// docs/DESIGN.md.
// `inverse` swaps the two for art on an inverse panel, which is dark in the
// light theme and light in the dark one. Only transparent art can do this.
export const Illustration = ({ name, className, inverse = false }) => {
  const [light, dark] = inverse ? [...ART[name]].reverse() : ART[name];
  return (
    <>
      <img src={light} alt="" className={cn('aspect-[3/2] object-cover dark:hidden', className)} />
      <img src={dark} alt="" className={cn('aspect-[3/2] object-cover hidden dark:block', className)} />
    </>
  );
};
